module.exports = __webpack_public_path__ + "static/media/dealer_b_960.545fa6d3.png";